import { render, staticRenderFns } from "./AboutHimi.vue?vue&type=template&id=d2801750&scoped=true&"
import script from "./AboutHimi.vue?vue&type=script&lang=js&"
export * from "./AboutHimi.vue?vue&type=script&lang=js&"
import style0 from "./AboutHimi.vue?vue&type=style&index=0&id=d2801750&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d2801750",
  null
  
)

export default component.exports